import { useCallback, useState } from "react";
import FormTextInput from "Components/FormInput";
import {useDispatch} from 'react-redux';

// import puzzleGenieLogo from 'Assets/newsie-triumphant-192-removebg.png'
import puzzleGenieLogo from "Assets/PuzzleGenieNoLogo.png";

import "./PuzzleGenieLogin.css";
import { setPublicModal, dismissPublicModal} from "Store/features/public/publicStateSlice";
import { MODALS } from "../..";

const CREATE_ACCONT_FORM_LABELS = {
  USERNAME: "Username",
  EMAIL: "Email",
  PASSWORD: "Password",
};

const PuzzleGenieLogin = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();

  const handleEmailChange = useCallback(
    (e) => {
      setEmail(e.target.value);
    },
    [setEmail]
  );

  const handlePasswordChange = useCallback(
    (e) => {
      setPassword(e.target.value);
    },
    [setPassword]
  );

  const handleCickCreateAccount=  useCallback(
    () => {
      dispatch(dismissPublicModal())
      dispatch(setPublicModal(MODALS.CREATE_ACCOUNT))
    },
    [dispatch],
  )
  return (
    <div className="public-puzzle-genie-login-modal">
      <div
        className="public-puzzle-genie-login-form-container"
        onClick={(e) => e.stopPropagation()}
      >
        <img src={puzzleGenieLogo} />
        <div className="public-puzzle-genie-login-form-description">
          PuzzleGenie Login
        </div>
        <FormTextInput
          inputLabel={CREATE_ACCONT_FORM_LABELS.EMAIL}
          onChange={handleEmailChange}
          value={email}
        />
        <FormTextInput
          inputLabel={CREATE_ACCONT_FORM_LABELS.PASSWORD}
          onChange={handlePasswordChange}
          value={password}
        />
        <div className="public-puzzle-genie-login-modal-login-button">
          Login
        </div>
        or
        <div className="create-account-button" 
        onClick={handleCickCreateAccount}
        >
          Create Account
        </div>
      </div>
    </div>
  );
};

export default PuzzleGenieLogin;
